module.exports = __webpack_public_path__ + "media/images/blank-profile-photo-1e83596a13a97824fc0927110e048a0d.jpg";